import React, {
  useEffect, useRef, useLayoutEffect, useState,
} from 'react';
import {
  Formik,
  Form as FormikForm,
  Field,
  ErrorMessage,
  useFormikContext,
  useField,
  FieldProps,
  useFormik,
} from 'formik';

import { FormGroup, InputGroup } from 'react-bootstrap';

import Select from 'react-select';
import Switch from 'react-switch';

export function Form(props) {
  return (
    <Formik {...props}>
      <FormikForm className="needs-validation" noValidate="">
        {props.children}
      </FormikForm>
    </Formik>
  );
}

export function DisableTextField(props) {
  const { label, hint, ...rest } = props;
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="form-group">
        <Field
          autoComplete="off"
          className="form-control"
          type="text"
          disabled
          {...rest}
        />
        {hint && <div className="form-text text-muted">{hint}</div>}
      </div>
    </>
  );
}

export function TextField(props) {
  const {
    name, label, placeholder, type, hint, ...rest
  } = props;

  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;

  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="form-group">
        <Field
          autoComplete="off"
          className="form-control"
          type={type || 'text'}
          name={name}
          id={name}
          placeholder={placeholder || ''}
          onChange={(e) => setValue(e.target.validity.valid || e.target.pattern === '' ? e.target.value : field.value)}
          {...rest}
        />
        {hint && <div className="form-text text-muted">{hint}</div>}
        <ErrorMessage
          name={name}
          render={(msg) => <div style={{ color: 'red' }}>{msg}</div>}
        />
      </div>
    </>
  );
}

export function TextFieldWithAddon(props) {
  const {
    name, addon, label, placeholder, type, hint, ...rest
  } = props;

  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;

  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="form-group">
        <div className="input-group">
          <Field
            autoComplete="off"
            className="form-control"
            type={type || 'text'}
            name={name}
            id={name}
            placeholder={placeholder || ''}
            onChange={(e) => setValue(e.target.validity.valid || e.target.pattern === ''
              ? e.target.value : field.value)}
            {...rest}
          />
          <InputGroup.Addon>{addon}</InputGroup.Addon>
        </div>
        {hint && <div className="form-text text-muted">{hint}</div>}
        <ErrorMessage
          name={name}
          render={(msg) => <div style={{ color: 'red' }}>{msg}</div>}
        />
      </div>
    </>
  );
}

export function DateField(props) {
  const [field, meta, helpers] = useField(props);

  const {
    name, label, placeholder, type, ...rest
  } = props;
  const { setValue } = helpers;

  const elRef = useRef(null);

  useEffect(() => {
    $(elRef.current)
      .find('.input-datepicker')
      .datepicker({
        todayBtn: 'linked',
        keyboardNavigation: false,
        forceParse: false,
        autoclose: true,
        format: 'MM dd, yyyy',
        disableTouchKeyboard: true,
        immediateUpdates: true,
        startView: 0,
      })
      .on('changeDate', (e) => {
        setValue(e.format());
      });
  }, []);

  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div ref={elRef} className="form-group">
        <Field
          autoComplete="off"
          className="form-control input-datepicker"
          type={type || 'text'}
          name={name}
          id={name}
          placeholder={placeholder || ''}
          onChange={(value) => {}}
          {...rest}
        />
        <ErrorMessage
          name={name}
          render={(msg) => <div style={{ color: 'red' }}>{msg}</div>}
        />
      </div>
    </>
  );
}

export function TextAreaField(props) {
  const {
    name, label, placeholder, required, ...rest
  } = props;
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="form-group">
        <Field
          autoComplete="off"
          className="form-control"
          type="text"
          name={name}
          as="textarea"
          id={name}
          placeholder={placeholder || ''}
          {...rest}
        />
        <ErrorMessage
          name={name}
          render={(msg) => <div style={{ color: 'red' }}>{msg}</div>}
        />
      </div>
    </>
  );
}

export function SelectFieldV2(props) {
  const {
    options,
    name,
    label,
    isMulti = false,
    placeholder = 'Select',
    ...rest
  } = props;

  const [field, meta, helpers] = useField(props);
  const { setValue, setTouched } = helpers;

  function onChange(option) {
    setValue(option ? option.map((item) => item.value) : []);
  }

  const getValue = () => {
    if (options) {
      return isMulti
        ? options.filter((option) => field.value && field.value.indexOf(option.value) >= 0)
        : options.find((option) => option.value === field.value);
    }
    return isMulti ? [] : '';
  };

  if (!isMulti) {
    return (
      <>
        {label && <label htmlFor={name}>{label}</label>}
        <div className="react-select2 form-group">
          <Select
            className="form-control"
            options={options}
            name={field.name}
            value={
              options
                ? options.find((option) => option.value === field.value)
                : ''
            }
            onChange={(option) => {
              setTouched();
              setValue(option?.value);
            }}
            onBlur={() => setTouched()}
            placeholder={placeholder}
            {...rest}
          />
          <ErrorMessage
            name={field.name}
            render={(msg) => <div style={{ color: 'red' }}>{msg}</div>}
          />
        </div>
      </>
    );
  }
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="react-select2 form-group">
        <Select
          className="form-control"
          name={field.name}
          value={getValue()}
          onChange={onChange}
          options={options}
          isMulti
          placeholder={placeholder}
          {...rest}
        />
      </div>
    </>
  );
}

export const SelectField = React.forwardRef((props, ref) => {
  const [field, meta, helpers] = useField(props);

  const {
    options, name, label, ...rest
  } = props;
  const { touched, error, value } = meta;
  const { setValue } = helpers;

  let rightValue = null;

  if (value != null && value != undefined && options != null) {
    rightValue = options.find((item) => item.value == value);
  }

  const [selected, setSelected] = useState(rightValue || value);

  const selectOption = props.isSelectAll
    ? [
      { label: `${props.selectAll} (${options.length})`, value: 'all' },
      ...options,
    ]
    : options;

  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="react-select2 form-group">
        <Select
          value={selected}
          ref={ref}
          className="form-control"
          id={name}
          name={name}
          options={selectOption}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 99999 }),
          }}
          menuPortalTarget={document.body}
          isClearable
          onChange={(option) => {
            if (option == null) {
              setValue(null);
              setSelected(null);
            } else if (Array.isArray(option)) {
              if (
                option.length > 1
                && option[option.length - 1].value == 'all'
              ) {
                option = [option[option.length - 1]];
              }
              if (option.length > 1) {
                option = option.filter((item) => item.value != 'all');
              }
              setSelected(option);
              if (option.length == 1 && option[0].value == 'all') {
                setValue(
                  selectOption
                    .filter((item) => item.value != 'all')
                    .map((element) => element.value),
                );
              } else {
                setValue(option.map((element) => element.value));
              }
            } else {
              setValue(option.value);
              setSelected(option);
            }
            if (props.onCustomonChange != undefined) {
              props.onCustomonChange(option);
            }
          }}
          {...rest}
        />
        <ErrorMessage
          name={name}
          render={(error) => <div style={{ color: 'red' }}>{error}</div>}
        />
      </div>
    </>
  );
});

export function CheckBoxField(props) {
  const {
    name, label, options, inline, ...rest
  } = props;
  return (
    <>
      <label className={inline ? 'checkbox-inline' : ''}>
        <Field type="checkbox" name={name} id={name} {...rest} />
        {label}
      </label>
      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: 'red' }}>{msg}</div>}
      />
    </>
  );
}

export function RadioButtonsField(props) {
  const {
    name, label, options, ...rest
  } = props;
  return (
    <>
      {options.map((item, index) => (
        <label key={index} className="checkbox-inline">
          <Field
            type="radio"
            name={name}
            value={item.value}
            {...rest}
            style={{ marginRight: '5px' }}
          />
          {item.label}
        </label>
      ))}

      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: 'red' }}>{msg}</div>}
      />
    </>
  );
}

export function FileField(props) {
  const [field, meta, helpers] = useField(props);

  const { name, label, ...rest } = props;
  const { setValue } = helpers;

  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="form-group">
        <input
          name={name}
          type="file"
          onChange={(event) => setValue(event.target.files[0])}
          {...rest}
        />
        <ErrorMessage
          name={name}
          render={(msg) => <div style={{ color: 'red' }}>{msg}</div>}
        />
      </div>
    </>
  );
}

export function CancelPopupButton(props) {
  const { title, ...rest } = props;

  return (
    <a className="btn btn-primary width-100 btn-outline mr5 ml5" {...rest}>
      {title}
    </a>
  );
}

export function SubmitButton(props) {
  const { title, ...rest } = props;
  const { isSubmitting } = useFormikContext();

  return (
    <button
      className="btn width-100 btn-primary submit-button mr5 ml5"
      type="submit"
      {...rest}
      disabled={isSubmitting}
    >
      {title}
    </button>
  );
}

export function SwitchField(props) {
  const { name, label, ...rest } = props;

  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;

  function onChange(checked) {
    setValue(checked);
  }

  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="form-group">
        <Switch
          name={field.name}
          onChange={onChange}
          checked={field.value}
          onColor="#77c54f"
          uncheckedIcon={false}
          checkedIcon={false}
          className="react-switch"
          {...rest}
        />
        <ErrorMessage
          name={field.name}
          render={(msg) => <div style={{ color: 'red' }}>{msg}</div>}
        />
      </div>
    </>
  );
}
